/**
 * @desc generate color
 */
import { Color, brighten as colorBrighten, alpha } from '@byted/light-render/lib/color';
export var generateColors = generate;
export { Color, alpha };
export function brighten(color, rate) {
    if (rate === void 0) { rate = 0.1; }
    return colorBrighten(color, rate);
}
function generate(color) {
    var colorScaleLimit = 11;
    var colors = Array(colorScaleLimit).fill(color, 0, colorScaleLimit);
    return colors.map(function (main, index) {
        return index === 5 ? main : colorPalette(main, index + 1);
    });
}
function colorPalette(color, index) {
    var darkestL = 16;
    var lightestL = 96;
    var colorObj = Color(color);
    var hsl = {
        h: colorObj.hue(),
        s: colorObj.saturationl(),
        l: colorObj.lightness(),
    };
    var curLight = hsl.l;
    var light = 0;
    var darkStep = (curLight - darkestL) / 5;
    var lightStep = (lightestL - curLight) / 5;
    if (index === 6) {
        light = hsl.l;
    }
    else if (index < 6) {
        light = curLight + (6 - index) * lightStep;
    }
    else if (index > 6) {
        light = curLight - (index - 6) * darkStep;
    }
    return Color({
        h: Math.round(hsl.h),
        s: hsl.s,
        l: light,
    }).hex();
}
